import { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';
import { ExploreTabRouterEnum, HomeTabRouterEnum } from '@/app/types';

export type TabItem = {
  key: HomeTabRouterEnum | ExploreTabRouterEnum;
  label: string | React.ReactNode;
  icon?: React.ReactNode;
};

export const useExploreTabs = (isExplore?: boolean) => {
  const t = useTranslations();
  const tabs: TabItem[] = [];

  if (!isExplore) {
    tabs.push({
      key: HomeTabRouterEnum.Recommend,
      label: t('homeTab.recommended'),
    });
  }

  if (isExplore) {
    tabs.push({
      key: ExploreTabRouterEnum.Inspiration,
      label: t('homeTab.mediaAsset'),
    });
  }

  tabs.push({
    key: ExploreTabRouterEnum.Cases,
    label: t('homeTab.cases'),
  });

  tabs.push({
    key: ExploreTabRouterEnum.PostReferences,
    label: t('homeTab.sharedReferences'),
  });

  // china 首页只保留 推荐/主体，短片/教程/活动 收入推荐的二级筛选 tab
  if (isExplore || SITE !== 'china') {
    tabs.push(
      {
        key: ExploreTabRouterEnum.ShortFilm,
        label: t('homeTab.shortFilm'),
      },
      {
        key: ExploreTabRouterEnum.Tutorial,
        label: t('homeTab.tutorial'),
      },
      {
        key: HomeTabRouterEnum.Activity,
        label: t('homeTab.activity'),
      },
    );
  }

  return tabs;
};
